export default {
  999: { label: 'Other' },
  999999: { label: 'Other' },
  '001': { label: 'Membership' },
  '001001': {
    label: 'Sign Up',
    inclusion: [
      'Templates for sign-up completion, welcome reward points, and coupons',
    ],
    exclusion: [
      'For product or service sign-up templates, please select “Purchase > Product Sign-Up."',
    ],
  },
  '001002': {
    label: 'Verification / Password / Login',
    inclusion: [
      'Templates for OTP, login status, temporary passwords, and identity verification',
    ],
  },
  '001003': {
    label: 'Member Info / Benefits',
    inclusion: [
      'Templates for membership level, benefit info, and birthday/anniversary greetings',
    ],
  },
  '002': { label: 'Purchase' },
  '002001': {
    label: 'Purchase Completed',
    inclusion: [
      'Templates for order completion or purchase confirmation',
    ],
    exclusion: [
      'Templates with scheduling or reservation numbers should be categorized under “Reservation."',
    ],
  },
  '002002': {
    label: 'Product Sign-Up',
    inclusion: [
      'Templates for product subscription/contract completion, service activation, recurring payment products, and rental sign-ups',
    ],
    exclusion: [
      'Templates related to membership registration should be categorized under “Membership > Sign Up.”',
    ],
  },
  '002003': { label: 'Status' },
  '002004': {
    label: 'Purchase Cancellation',
    inclusion: [
      'Templates for purchase cancellations due to sold-out items, refunds, product/service/rental cancellations',
    ],
  },
  '002005': {
    label: 'Pre-order / Back-in-stock Notification',
    inclusion: ['Templates for restock notifications and pre-orders'],
  },
  '003': { label: 'Reservation' },
  '003001': {
    label: 'Reservation Confirmation / History',
    inclusion: [
      'Templates for reservation confirmation, ticket bookings, service/medical bookings, venue reservations, consultation appointments, and reservation payment confirmations',
    ],
    exclusion: [
      'Templates for reservation status updates (modifications, confirmations, payment pending, ticket issued, used, waiting, schedule changes, seat assignments, mobile check-in, etc.)',
      'For usage guidance of reserved services, please select “Service Use > Usage Info.”',
    ],
  },
  '003003': {
    label: 'Reservation Cancellation',
    inclusion: ['Templates for failed or canceled reservations'],
  },
  '009': { label: 'Coupon / Point' },
  '009001': {
    label: 'Coupon Issuance',
    inclusion: [
      'Templates for issuing free or discount coupons for products/services',
    ],
    exclusion: [
      'Templates for vouchers, tickets, etc. issued during purchase are not included.',
      'For notifications about coupon expiration or usage, please select “Coupon / Point Info.”',
    ],
  },
  '009002': {
    label: 'Coupon Usage',
    inclusion: [
      'Templates notifying coupon usage completion for free or discounted offers',
    ],
    exclusion: [
      'Templates for vouchers, tickets, etc. issued during purchase are not included.',
      'For notifications about coupon expiration or usage, please select “Coupon / Point Info.”',
    ],
  },
  '009003': {
    label: 'Point Accrual',
    inclusion: [
      'Templates for reward point, mileage, or store credit accrual completion',
    ],
    exclusion: [
      'For information on accrual methods or validity, please select “Coupon / Point Info.”',
    ],
  },
  '009004': {
    label: 'Point Usage',
    inclusion: [
      'Templates for the use of customer rewards such as points, mileage, and store credit',
    ],
    exclusion: [
      'For information on accrual methods or validity, please select “Coupon / Point Info.”',
    ],
  },
  '009005': {
    label: 'Coupon / Point Info',
    inclusion: [
      'Templates for usage instructions, expiration notices, policy changes, and validity periods of coupons, points, store credit, and mileage',
    ],
  },
  '005': { label: 'Reporting' },
  '005001': {
    label: 'Feedback',
    inclusion: [
      'Templates for customer inquiry responses, attendance and online/offline status feedback, process result updates, attendance confirmation, security deactivation, and event winner announcements',
    ],
  },
  '005002': {
    label: 'Billing',
    inclusion: [
      'Templates for bills, upcoming payment notices, expected payment amounts, receipts, tax invoices, and transaction statements',
    ],
    exclusion: [
      'For financial-related billing (e.g., interest payments, insurance premiums), please select the “Other” category.',
    ],
  },
  '005003': {
    label: 'Contract / Quotation',
    inclusion: {
      0: 'Templates for contracts, quotations, and contract signing requests',
    },
  },
  '005004': {
    label: 'Safety / Risk Prevention',
    inclusion: [
      'Templates related to voice phishing prevention, fraud prevention, and disaster-related risk alerts such as weather',
    ],
  },
  '005005': {
    label: 'Newsletter',
    inclusion: [
      'Templates sent regularly to members for sharing new updates and information',
    ],
  },
  '005006': {
    label: 'Transaction Alerts',
    inclusion: [
      'Templates used by financial institutions (banks, securities, credit card companies) or payment processors to notify users of transaction statuses and results',
    ],
  },
  '006': { label: 'Delivery' },
  '006001': {
    label: 'Delivery Status',
    inclusion: [
      'Templates for the status of delivery, customs clearance, or pickup',
    ],
    exclusion: ['Templates for upcoming delivery, visits, or pickups'],
  },
  '006003': {
    label: 'Delivery Completed',
    inclusion: [
      'Templates indicating successful delivery or pickup by a courier',
    ],
  },
  '004': { label: 'Service Use' },
  '004001': {
    label: 'Usage Guide / Notices',
    inclusion: [
      'Templates related to issuance instructions, usage guides, notifications of changes, or service status alerts',
    ],
  },
  '004002': {
    label: 'Application Submission',
    inclusion: [
      'Templates for applications unrelated to purchases/reservations such as service enrollment, certificate issuance, class registration, admission applications, service cancellations, event participation, and qualification submissions',
    ],
  },
  '004003': {
    label: 'Processing Completed',
    inclusion: [
      'Templates for order completion or processing confirmation',
    ],
  },
  '004004': {
    label: 'Usage Tools',
    inclusion: [
      'Templates used to verify service eligibility or access, such as mobile boarding passes, tickets, or QR codes',
    ],
    exclusion: [
      'For issuance-related notices, please select "Service Use > Usage Guide".',
    ],
  },
  '004005': {
    label: 'On-site Service',
    inclusion: [
      'Templates for scheduled visits (e.g., rental product maintenance)',
    ],
    exclusion: [
      'For rental contract templates, select "Purchase > Product Sign-Up".',
    ],
  },
  '004006': {
    label: 'Feedback Request',
    inclusion: [
      'Templates encouraging recipient participation (e.g., satisfaction surveys, survey requests, review requests)',
    ],
  },
  '004007': {
    label: 'Purchase Thanks / Usage Confirmation',
    inclusion: [
      'Templates for thank-you messages and service usage confirmations',
    ],
  },
  '004008': {
    label: 'Reminders',
    inclusion: [
      'Templates for reminders such as sequence notices, upcoming date alerts, dispatch notifications, reservation end notices, and due date alerts for borrowed books',
    ],
  },
  '007': { label: 'Legal Notices' },
  '007001': {
    label: 'Consent to Receive',
    inclusion: [
      'Templates for marketing opt-in and promotional message consent',
    ],
  },
  '007002': {
    label: 'Personal Information',
    inclusion: [
      'Templates related to privacy laws, including consent to provide personal information, data collection sources, and third-party processing agreements',
    ],
  },
  '007003': {
    label: 'Terms Changes',
    inclusion: [
      'Templates notifying updates to terms of service or membership agreements',
    ],
  },
  '007004': {
    label: 'Dormancy Notices',
    inclusion: [
      'Templates notifying the upcoming or completed conversion of an account to dormant status due to prolonged inactivity',
    ],
  },
  '008': { label: 'Business Alerts' },
  '008001': {
    label: 'Order / Reservation',
    inclusion: [
      'Templates for orders or reservations received by the business (including cancellations)',
    ],
  },
  '008002': {
    label: 'Internal Business Notifications',
    inclusion: [
      'Templates used to notify internal team members or stakeholders for work or administrative purposes',
    ],
  },
};
